import styled from 'styled-components';
import { Color, Font } from '@figure/frontlib-gui';

import BodyBase from './BodyBase';

/** base typography elements */
export const H1 = styled.h1`
  font-family: ${Font.HEADER_FONT};
  font-weight: 400;
  font-size: 2.4rem;
  color: ${Color.BLACK_SOUL};
  margin: 0;
`;

export const H2 = styled.h2`
  font-family: ${Font.HEADER_FONT};
  font-weight: 400;
  font-size: 2.2rem;
  color: ${Color.BLACK_SOUL};
  margin: 0;
`;

export const H3 = styled.h3`
  font-family: ${Font.HEADER_FONT};
  font-weight: 500;
  font-size: 1.8rem;
  color: ${Color.BLACK_SOUL};
  margin: 0;
`;

export const H4 = styled.h4`
  font-family: ${Font.SECONDARY_HEADER_FONT};
  font-weight: 700;
  font-size: 2rem;
  letter-spacing: -0.5px;
  color: ${Color.BLACK_SOUL};
  margin: 0;
`;

/** specific typography elements */
export const PageHeader = styled(H1)`
  color: ${Color.PURPLE_RAIN};
  margin-bottom: 20px;
`;

export const PageHeaderShort = styled(H1)`
  color: ${Color.PURPLE_RAIN};
  margin-bottom: 24px;
`;

export const Body = styled(BodyBase)`
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.46;
`;

export const SubPageHeader = styled(Body)`
  margin-bottom: 40px;
`;

export const BodyBold = styled(BodyBase)`
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.46;
`;

export const SmallBody = styled(BodyBase)`
  font-size: 1.3rem;
  font-weight: 400;
  line-height: 1.69;
`;

export const SmallBodyGrey = styled(BodyBase)`
  font-size: 1.3rem;
  font-weight: 400;
  line-height: 1.69;
  color: ${Color.DARK_GREY_2};
`;

export const SmallBodyBold = styled(BodyBase)`
  font-size: 1.3rem;
  font-weight: 600;
  line-height: 1.69;
`;

export const Error = styled(SmallBodyBold)`
  color: ${Color.ERROR};
`;

export const Legal = styled(SmallBody)`
  font-size: 1.1rem;
  font-weight: 300;
`;
